import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';

const buttonAnimationMixin = {
	props: {
		animated: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		animate(callback) {
			const buttonText = this.$refs.buttonText;
			Velocity(buttonText, {
				translateY: '-2rem',
				opacity: 0,
			}, {
				duration: 544,
				ease: 'easeInOut',
				complete: () => {
					Velocity(buttonText, {
						translateY: '2rem',
					}, {
						duration: 0,
					}).then(() => {
						Velocity(buttonText, {
							opacity: 1,
							translateY: '0rem',
						}, {
							duration: 544,
							ease: 'easeInOut',
						});
					});
				},
			});
			const buttonIcon = this.$refs.buttonIcon;
			Velocity(buttonIcon, {
				opacity: 1,
				translateY: '-1.8rem',
			}, {
				duration: 544,
				ease: 'easeInOut',
				complete: () => {
					Velocity(buttonIcon, {
						opacity: 0,
						translateY: '-2.8rem',
					}, {
						duration: 544,
					}).then(() => {
						Velocity(buttonIcon, {
							translateY: '0rem',
						}, {
							duration: 0,
						});
						callback();
					});
				},
			});
		},
	},
};

export default buttonAnimationMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/buttonAnimationMixin.js